// extracted by mini-css-extract-plugin
export default {"container":"jF-z","header":"kF-z","details":"lF-z","link":"mF-z"};